import { useEffect, useState } from "react";
import { urlToBase64 } from "@/shared/components/report-template/utils/url-to-base64";

export const useImgBase64 = (url: string) => {
  const [img, setImg] = useState<string>("");
  useEffect(() => {
    urlToBase64(`${url}?${Date.now()}`).then((base64) => {
      setImg(base64 ?? "");
    });
  }, [url]);
  return [img];
};
